import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import { applicationDetail } from "../../actions/v3/applicationDetail";
import { Link } from "react-router-dom";
import { use } from "i18next";
import PdfViewerModal from "../application/components/PdfViewerModal";

function ApplicationDetailV2(props) {
  const { Id } = useParams();
  const dispatch = useDispatch();
  const IsDoctor = localStorage.getItem("IsDoctor")
    ? localStorage.getItem("IsDoctor")
    : false;

  const IsNurse = localStorage.getItem("IsNurse")
    ? localStorage.getItem("IsNurse")
    : false;

  useEffect(() => {
    if (props.applicationDetail?.applicationDetail?.result) {
      const attachments =
        props.applicationDetail.applicationDetail.result.attachments;

      if (attachments) {
        attachments.forEach((attachment) => {
          if (
            attachment.viewUrl?.endsWith(".html") ||
            attachment.uploadUrl?.endsWith(".html")
          ) {
            console.warn("HTML dosyaları yönlendirmeye çalışıyor!");
          }
        });
      }
    }
  }, [props.applicationDetail]);

  useEffect(() => {
    dispatch(applicationDetail(Id));
  }, [dispatch]);

  const [pdfBlobUrl, setPdfBlobUrl] = useState("");

  useEffect(() => {
    const pdfData =
      props.applicationDetail?.applicationDetail?.result?.results[0]?.result;
    if (pdfData) {
      if (typeof pdfData === "string") {
        // Base64 kodlu string olup olmadığını kontrol edin
        const isBase64 = (str) => {
          try {
            return btoa(atob(str)) === str;
          } catch (err) {
            return false;
          }
        };

        if (isBase64(pdfData)) {
          try {
            const byteArray = new Uint8Array(
              atob(pdfData)
                .split("")
                .map((char) => char.charCodeAt(0))
            );
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            setPdfBlobUrl(url);
          } catch (error) {
            console.error("Failed to decode base64 string:", error);
          }
        } else {
          // Eğer base64 değilse, doğrudan URL olarak kullanın
          setPdfBlobUrl(pdfData);
        }
      } else if (pdfData instanceof Uint8Array) {
        const blob = new Blob([pdfData], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfBlobUrl(url);
      } else if (pdfData instanceof ArrayBuffer) {
        const byteArray = new Uint8Array(pdfData);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        setPdfBlobUrl(url);
      } else {
        console.error(
          "pdfData is neither a valid base64 string, Uint8Array, nor ArrayBuffer"
        );
      }
    }
  }, [props.applicationDetail]);

  return (
    <div>
      <Header />
      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li className="text-sm">
            <Link
              to="/applications"
              className="flex items-center text-gray-500 hover:text-[#09C35C]"
            >
              Başvurularım
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </Link>
          </li>
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            Başvuru Detayı
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      {props.applicationDetail.done ? (
        <div className="md:ml-64 ps-10 pe-5 mt-10">
          {IsDoctor === "true" ? (
            <>
              <button
                type="button"
                className="float-right  py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-red-500 text-red-500 hover:border-red-400 hover:text-red-400 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              >
                Başvuruyu reddet
              </button>
              <button
                type="button"
                className="float-right mr-3 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-teal-500 text-teal-500 hover:border-teal-400 hover:text-teal-400 disabled:opacity-50 disabled:pointer-events-none dark:border-teal-500 dark:text-teal-500 dark:hover:text-teal-400 dark:hover:border-teal-400 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              >
                Başvuruyu kabul et
              </button>
            </>
          ) : null}
          {IsNurse &&
          IsDoctor &&
          props.applicationDetail?.applicationDetail?.result
            ?.applicationStatus === 6 ? (
            <Link
              to={`/note-detail/${Id}`}
              className="float-right mr-3 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-500 text-gray-500 hover:border-gray-800 hover:text-gray-800 disabled:opacity-50 disabled:pointer-events-none dark:border-gray-400 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            >
              Başvuruya ilişkin notlar
            </Link>
          ) : null}
          <div
            className="border-b border-gray-200 dark:border-gray-700"
            style={{ paddingTop: "45px" }}
          >
            <nav className="flex space-x-2" aria-label="Tabs" role="tablist">
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C] active"
                id="tabs-with-badges-item-1"
                data-hs-tab="#tabs-with-badges-1"
                aria-controls="tabs-with-badges-1"
                role="tab"
              >
                Hasta Bilgileri
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                id="tabs-with-badges-item-2"
                data-hs-tab="#tabs-with-badges-2"
                aria-controls="tabs-with-badges-2"
                role="tab"
              >
                Talep Formu
              </button>
              <button
                type="button"
                className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                id="tabs-with-badges-item-3"
                data-hs-tab="#tabs-with-badges-3"
                aria-controls="tabs-with-badges-3"
                role="tab"
              >
                Dosyalar{" "}
                <span className="hs-tab-active:bg-blue-100 hs-tab-active:text-[#09C35C] dark:hs-tab-active:bg-blue-800 dark:hs-tab-active:text-white ml-1 py-0.5 px-1.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300">
                  {
                    props.applicationDetail.applicationDetail.result.attachments
                      .length
                  }
                </span>
              </button>
              {props.applicationDetail?.applicationDetail?.result
                ?.applicationStatus === 6 ? (
                <button
                  type="button"
                  className="hs-tab-active:font-semibold hs-tab-active:border-[#09C35C] hs-tab-active:text-[#09C35C] py-4 px-1 inline-flex items-center gap-2 border-b-[3px] text-red-500 font-bold border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-[#09C35C]"
                  id="tabs-with-badges-item-4"
                  data-hs-tab="#tabs-with-badges-4"
                  aria-controls="tabs-with-badges-4"
                  role="tab"
                >
                  Başvuru Sonucu
                </button>
              ) : null}
            </nav>
          </div>

          <div className="mt-3 text-start">
            <div
              id="tabs-with-badges-1"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-1"
            >
              <div className="info-container mt-5">
                {/* Hasta Bilgileri */}
                <div className="info-item">
                  <p className="info-title text-gray-500 dark:text-gray-400">
                    Hasta Adı Soyadı
                  </p>
                  <p className="info-content">
                    {props.applicationDetail?.applicationDetail?.result
                      ?.applicationRepresentedPerson
                      ? props.applicationDetail?.applicationDetail?.result
                          ?.applicationRepresentedPerson?.name +
                        " " +
                        props.applicationDetail?.applicationDetail?.result
                          ?.applicationRepresentedPerson?.surname
                      : props.applicationDetail?.applicationDetail?.result
                          ?.applicationOwnerUser?.name +
                        " " +
                        props.applicationDetail?.applicationDetail?.result
                          ?.applicationOwnerUser?.lastName}
                  </p>
                </div>
                <div className="info-item mt-3">
                  <p className="info-title text-gray-500 dark:text-gray-400">
                    Hasta Telefon Numarası
                  </p>
                  <p className="info-content">
                    {props.applicationDetail?.applicationDetail?.result
                      ?.applicationRepresentedPerson
                      ? props.applicationDetail?.applicationDetail?.result
                          ?.applicationRepresentedPerson?.phoneNumber
                        ? props.applicationDetail?.applicationDetail?.result
                            ?.applicationRepresentedPerson?.phoneNumber
                        : "-"
                      : props.applicationDetail?.applicationDetail?.result
                          ?.applicationOwnerUser?.phoneNumber}
                  </p>
                </div>

                <div className="info-item mt-3">
                  <p className="info-title text-gray-500 dark:text-gray-400">
                    Hasta Kimlik Numarası
                  </p>
                  <p className="info-content">
                    {props.applicationDetail?.applicationDetail?.result
                      ?.applicationRepresentedPerson
                      ? props.applicationDetail?.applicationDetail?.result
                          ?.applicationRepresentedPerson?.nationalIdentifier
                      : props.applicationDetail?.applicationDetail?.result
                          ?.applicationOwnerUser?.nationalId}
                  </p>
                </div>
                {/* Başvuran Bilgileri (Sadece temsilci varsa göster) */}
                {props.applicationDetail?.applicationDetail?.result
                  ?.applicationRepresentedPerson && (
                  <>
                    <div className="info-item mt-5">
                      <p className="info-title text-gray-500 dark:text-gray-400">
                        Başvuran Adı Soyadı
                      </p>
                      <p className="info-content">
                        {props.applicationDetail?.applicationDetail?.result
                          ?.applicationOwnerUser?.name +
                          " " +
                          props.applicationDetail?.applicationDetail?.result
                            ?.applicationOwnerUser?.lastName}
                      </p>
                    </div>
                    <div className="info-item mt-3">
                      <p className="info-title text-gray-500 dark:text-gray-400">
                        Başvuran Telefon Numarası
                      </p>
                      <p className="info-content">
                        {
                          props.applicationDetail?.applicationDetail?.result
                            ?.applicationOwnerUser?.phoneNumber
                        }
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div
              id="tabs-with-badges-2"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-2"
            >
              {/* <Link
                to={`/edit-triage/${Id}`}
                type="button"
                className="py-2 px-3 inline-flex justify-center items-end gap-2 rounded-md bg-gray-100 border border-transparent font-semibold text-gray-500 hover:text-white hover:bg-gray-500 focus:outline-none focus:ring-2 ring-offset-white focus:ring-gray-500 focus:ring-offset-2 transition-all text-sm dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-600 dark:text-white dark:focus:ring-offset-gray-800"
              >
                Düzenle
              </Link> */}
              <div className="flex flex-col border rounded-md p-4 ">
                <div className="-m-1.5 overflow-x-auto">
                  <div className="p-1.5 min-w-full inline-block align-middle">
                    <div className="overflow-hidden">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead>
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                            >
                              Başvuru Sorusu
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                            >
                              Cevabınız
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                          {Object.entries(
                            JSON.parse(
                              props.applicationDetail.applicationDetail.result
                                .survey.data
                            )
                          ).map(([key, value]) => {
                            return (
                              <tr key={key}>
                                <td>{key}</td>

                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
                                  {typeof value === "object" ? (
                                    Object.entries(value).map(([k, v]) => (
                                      <div key={k}>
                                        {k}:{" "}
                                        {typeof v === "object"
                                          ? Object.entries(v).map(
                                              ([ke, va]) => (
                                                <div key={ke}>
                                                  <b>{ke}</b> <p>{va}</p>
                                                </div>
                                              )
                                            )
                                          : v}
                                      </div>
                                    ))
                                  ) : (
                                    <div>{value}</div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="tabs-with-badges-3"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-3"
            >
              {props.applicationDetail.done ? (
                <div className="flex">
                  <div className="list-group mt-3 mb-3 w-full">
                    {props.applicationDetail.applicationDetail.result.attachments.map(
                      (element, index) => {
                        return (
                          <>
                            <div
                              key={index}
                              className="flex-container flex mt-3 flex-col py-2 px-3 bg-white border shadow-sm rounded-xl p-4 md:p-5 dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7] dark:text-gray-400"
                            >
                              <div className="flex justify-between flex-wrap">
                                <div className="flex justify-start gap-x-2">
                                  <a
                                    target="_blank"
                                    href={element.viewUrl}
                                    className="text-start py-2 px-3 inline-flex items-center text-xs font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 mb-2"
                                  >
                                    <i className="fa-light fa-eye mr-2"></i>{" "}
                                    Dosyayı Görüntüle
                                  </a>

                                  {!element.uploadUrl?.endsWith(".html") && (
                                    <a
                                      target="_blank"
                                      href={element.uploadUrl}
                                      onClick={(e) => {
                                        if (
                                          element.uploadUrl.endsWith(".html")
                                        ) {
                                          e.preventDefault();
                                          alert(
                                            "Bu dosyanın indirilmesine izin verilmiyor."
                                          );
                                        }
                                      }}
                                      className="text-start py-2 px-3 inline-flex items-center gap-x-2 text-xs font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-white dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 mb-2"
                                    >
                                      <i className="fa-light fa-floppy-disk mr-2"></i>{" "}
                                      Dosyayı İndir
                                    </a>
                                  )}
                                </div>

                                <div className="flex items-center space-x-2">
                                  <i className="fa-sharp fa-solid fa-circle-check onedose-color"></i>
                                  {/*   <a href="#" className="inline-flex">
                                    <i className="fa-thin fa-trash-can"></i>
                                  </a>  */}
                                </div>
                              </div>
                              <p
                                style={{ fontSize: "13px" }}
                                className="mt-2 mb-2"
                              >
                                {element.fileName}
                              </p>
                              <div className="flex w-full h-1.5 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700">
                                <div
                                  className="flex flex-col justify-center overflow-hidden bg-blue-500"
                                  role="progressbar"
                                  style={{
                                    width: `100%`,
                                    backgroundColor: `#09C35C`
                                  }}
                                  aria-valuenow="25"
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                ></div>
                              </div>
                            </div>
                            <div
                              id={`hs-vertically-centered-modal${index}`}
                              className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[100] overflow-x-auto overflow-y-auto"
                            >
                              <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                                <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                                  <div className="p-4 overflow-y-auto">
                                    <div className="ratio ratio-16x9">
                                      {!element.viewUrl?.endsWith(".html") &&
                                      !element.viewUrl?.endsWith(".mp4") &&
                                      !element.viewUrl?.endsWith(".mp3") ? (
                                        <iframe
                                          src={element.viewUrl}
                                          title="Dosya Görüntüleme"
                                          allowFullScreen
                                        ></iframe>
                                      ) : element.viewUrl?.endsWith(".mp4") ? (
                                        <video
                                          src={element.viewUrl}
                                          controls
                                          style={{
                                            width: "100%",
                                            height: "auto"
                                          }}
                                        />
                                      ) : element.viewUrl?.endsWith(".mp3") ? (
                                        <audio
                                          src={element.viewUrl}
                                          controls
                                          style={{ width: "100%" }}
                                        />
                                      ) : (
                                        <p className="text-red-500 text-center font-semibold">
                                          Bu dosya görüntülenemez.
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                    <button
                                      type="button"
                                      className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                      data-hs-overlay={`#hs-vertically-centered-modal${index}`}
                                    >
                                      Kapat
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              ) : null}
            </div>
            <div
              id="tabs-with-badges-4"
              className="hidden"
              role="tabpanel"
              aria-labelledby="tabs-with-badges-item-4"
            >
              {props.applicationDetail.done && pdfBlobUrl && (
                <PdfViewerModal pdfBlobUrl={pdfBlobUrl} />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-5 ps-5 pe-5 md:ml-64 text-start">
          <div className="relative">
            <div
              style={{ backgroundColor: `#09c35d7c` }}
              className="bg-blue-50 border border-blue-200 rounded-md p-4"
            >
              <div className="flex">
                <div className="flex-shrink-0">
                  <i className="fa-light fa-file"></i>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm text-blue-800 font-medium">
                    Detay yükleniyor
                  </h3>
                  <div className="text-sm text-blue-700 mt-2">
                    <span className="font-semibold">Lütfen bekleyin!</span>{" "}
                    Başvurunuzun detayı yükleniyor.
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div
                className="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                role="status"
                aria-label="loading"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationDetailV2);
